import { render, staticRenderFns } from "./ImmuneCard.vue?vue&type=template&id=ac8c56e6&scoped=true&"
import script from "./ImmuneCard.vue?vue&type=script&lang=js&"
export * from "./ImmuneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8c56e6",
  null
  
)

export default component.exports